import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { DatabaseViewFieldFragmentDoc } from './DatabaseViewField';
export type DatabaseViewFragment = { id: string, viewType: Types.ViewTypeEnum, format: { fields: Array<{ label?: string | null, width: number, fieldId: string, visible: boolean, required: boolean, description?: string | null, placeholder?: string | null, textType?: Types.DatabaseTextFormatEnum | null, allowCustomOptions?: boolean | null, descriptionEnabled?: boolean | null, minLabel?: string | null, maxLabel?: string | null }> }, query?: { sort?: Array<{ order: Types.OrderEnum, property: string }> | null, filterGroup?: { operator: Types.FilterOperatorEnum, filters: Array<{ value?: string | null, property?: string | null, operator: Types.FilterOperatorEnum, filters: Array<{ value: string, property: string, operator: Types.FilterOperatorEnum }> }> } | null } | null };


export type DatabaseViewFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const DatabaseViewFragmentDoc = /*#__PURE__*/ gql`
    fragment DatabaseView on DatabaseViewType {
  id
  viewType
  format {
    fields {
      ...DatabaseViewField
    }
  }
  query {
    sort {
      order
      property
    }
    filterGroup {
      operator
      filters {
        value
        property
        operator
        filters {
          value
          property
          operator
        }
      }
    }
  }
}
    `;